import { useRef, useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import PropTypes from 'prop-types';

/**
 * A reusable DataGrid wrapper that adds a top horizontal scrollbar.
 */
export default function TopScrollDataGrid({ height = 500, columns, rows, loading = false, style = {}, ...dataGridProps }) {
    const topScrollRef = useRef(null);
    const bottomScrollRef = useRef(null);
    const [totalWidth, setTotalWidth] = useState(0);

    // Sync both scrollbars
    const syncScroll = (source, target) => {
        if (target.current && source.target.scrollLeft !== target.current.scrollLeft) {
            target.current.scrollLeft = source.target.scrollLeft;
        }
    };

    // Dynamically calculate total width (update when columns change)
    useEffect(() => {
        const total = columns.reduce((sum, col) => sum + (col.width || 150), 0);
        setTotalWidth(total);
    }, [columns]);

    return (
        <div style={{ width: '100%', ...style }}>
            {/* --- Top Scrollbar --- */}
            <div
                ref={topScrollRef}
                style={{
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    height: 16,
                    marginBottom: 4
                }}
                onScroll={(e) => syncScroll(e, bottomScrollRef)}
            >
                <div style={{ width: totalWidth, height: 1 }} />
            </div>

            {/* --- DataGrid with Bottom Scrollbar --- */}
            <div ref={bottomScrollRef} style={{ height, width: '100%', overflowX: 'auto' }} onScroll={(e) => syncScroll(e, topScrollRef)}>
                <DataGrid {...dataGridProps} columns={columns} rows={rows} loading={loading} style={{ minWidth: totalWidth }} />
            </div>
        </div>
    );
}
TopScrollDataGrid.propTypes = {
    height: PropTypes.number,
    columns: PropTypes.array,
    rows: PropTypes.array,
    loading: PropTypes.bool,
    style: PropTypes.object
};
